import { render, staticRenderFns } from "./EditCard.vue?vue&type=template&id=08ca406a&scoped=true"
import script from "./EditCard.vue?vue&type=script&lang=ts"
export * from "./EditCard.vue?vue&type=script&lang=ts"
import style0 from "./EditCard.vue?vue&type=style&index=0&id=08ca406a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ca406a",
  null
  
)

export default component.exports